import React, {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {ApiService} from "../../../services/ApiService";
import {Button, Card, Checkbox, Col, Divider, message, Popconfirm, Row, Space} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";

const UserEditPage = () => {
    const [searchParams] = useSearchParams()
    const navigator = useNavigate()
    const userId = searchParams.get('userId')

    const [user, setUser] = useState({})
    const [checked, setChecked] = useState({})
    const [accesses, setAccesses] = useState([])

    const requestUserAccesses = () => {
        ApiService.admin.system.user.access.list(userId)
            .onSuccess(data => {
                setChecked(data.right)
                setAccesses(data.left)
            })
    }

    const requestUserInfo = () => {
        ApiService.admin.system.user.get(userId)
            .onSuccess(data => {
                setUser(data)
            })
    }

    useEffect(() => {
        requestUserInfo()
        requestUserAccesses()
    }, [userId]);


    const handleCheckBoxChange = (event) => {
        const value = event.target.value
        const isChecked = event.target.checked
        if (!isChecked) {
            const c = checked.filter(i => i !== value)
            setChecked(c)
        } else {
            setChecked([...checked, value])
        }
    }

    const handleCheckAll = (event) => {
        const isChecked = event.target.checked
        if (isChecked) {
            setChecked(accesses.map(i => {return i.value}))
        } else {
            setChecked([])
        }
    }

    const handleSubmit = (event) => {
        ApiService.admin.system.user.access.update(userId, checked)
            .onSuccess(() => {
                message.success("数据已保存")
                navigator(-1)
            })
    }

    return (
        <>
            <Card title={`${user.username} 的访问控制`}>
                <div style={{paddingBottom: 5}}>
                    <Row>
                        <Col>
                            <Checkbox checked={checked.length === accesses.length} onClick={handleCheckAll}><span style={{fontSize: 17}}>授权全部</span></Checkbox>
                        </Col>
                    </Row>
                    <Divider/>
                    <Row>
                        {
                            accesses.map(item => {
                                    return <Col xs={24} sm={12} key={item.value}>
                                        <Checkbox style={{marginBottom: 15}}
                                                  checked={checked.indexOf(item.value) > -1}
                                                  value={item.value}
                                                  onChange={handleCheckBoxChange}>
                                            <span style={{fontSize: 17}}>{item.name}</span>
                                        </Checkbox>
                                    </Col>
                                }
                            )
                        }
                    </Row>
                </div>
                <Row justify="end" style={{paddingTop: 30}}>
                    <Space>
                        <Popconfirm
                            placement="topRight"
                            title="确定要取消编辑吗"
                            icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                            onConfirm={e => {navigator(-1)}}
                            okText="确定"
                            cancelText="暂不"
                        >
                            <Button>取消</Button>
                        </Popconfirm>
                        <Popconfirm
                            placement="topRight"
                            title="确定要提交吗"
                            onConfirm={handleSubmit}
                            okText="确定"
                            cancelText="暂不"
                        >
                            <Button type="primary">提交</Button>
                        </Popconfirm>
                    </Space>
                </Row>
            </Card>
        </>
    )
}

export default UserEditPage